import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ActionSheetController,
  AlertController,
  ModalController,
} from '@ionic/angular';
import { MapModalComponent } from '../../map-modal/map-modal.component';
import { Geolocation } from '@capacitor/geolocation';
import { Capacitor } from '@capacitor/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { PlaceLocation } from '../../../vets-near-by/location.model';

@Component({
  selector: 'app-location-picker',
  templateUrl: './location-picker.component.html',
  styleUrls: ['./location-picker.component.scss'],
})
export class LocationPickerComponent implements OnInit, OnDestroy {
  @Output() locationSet = new EventEmitter<{ lat: number; lng: number }>();
  pickedLocation: PlaceLocation;
  constructor(
    private modalCtrl: ModalController,
    private actionSheetCtrl: ActionSheetController,
    private alertCtrl: AlertController,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.getUserLocation();
  }

  public getUserLocation() {
    if (!this.pickedLocation) {
      this.locateUser();
    } else {
      this.locationSet.emit({
        lat: this.pickedLocation.lat,
        lng: this.pickedLocation.lng,
      });
    }
  }

  ngOnDestroy(): void {
  }
  onPickLocation() {
    this.actionSheetCtrl
      .create({
        buttons: [
          {
            text: 'Use Current Location',
            icon: 'location-outline',
            handler: () => {
              this.locateUser();
            },
            cssClass: 'actionsheetbutton',
          },
          {
            text: 'Pick on Map',
            icon: 'map-outline',
            handler: () => {
              this.openMap();
            },
            cssClass: 'actionsheetbutton',
          },
        ],
      })
      .then((actionSheetEl) => actionSheetEl.present());
  }

  private locateUser() {
    if (!Capacitor.isPluginAvailable('Geolocation')) {
      this.showError();
      return;
    }
    Geolocation.getCurrentPosition({
      enableHighAccuracy: true, // Request high accuracy location
      timeout: 10000, // Timeout in milliseconds
    })
      .then((geoPosition) => {
        this.pickedLocation = {
          lat: geoPosition.coords.latitude,
          lng: geoPosition.coords.longitude,
          address: null,
          staticMapImageUrl: null,
        };
        this.setImageAfterLocationChange();
      })
      .catch((err) => {
        this.showError();
      });
  }
  private showError() {
    this.alertCtrl
      .create({
        header: 'Location not available',
        message:
          'Please enable location services and ensure that permissions are granted.',
        buttons: [
          {
            text: 'Pick on Map',
            handler: () => {
              this.openMap();
            },
          },
          { text: 'Dismiss' },
        ],
      })
      .then((alertEl) => alertEl.present());
  }
  private openMap() {
    let mapCenter;
    if (this.pickedLocation) {
      mapCenter = {
        lat: this.pickedLocation.lat,
        lng: this.pickedLocation.lng,
      };
    } else {
      mapCenter = { lat: -34.379, lng: 150.644 };
    }
    this.modalCtrl
      .create({
        component: MapModalComponent,
        componentProps: { center: mapCenter },
      })
      .then((modalEl) => {
        modalEl.onDidDismiss().then((modalData) => {
          if (!modalData.data) {
            return;
          }
          this.pickedLocation = {
            lat: modalData.data.lat,
            lng: modalData.data.lng,
            address: null,
            staticMapImageUrl: null,
          };
          this.setImageAfterLocationChange();
        });
        modalEl.present();
      });
  }

  private setImageAfterLocationChange() {
    const imageUrl = this.getMapImage(
      this.pickedLocation.lat,
      this.pickedLocation.lng,
      14
    );

    this.pickedLocation.staticMapImageUrl = imageUrl;
    this.locationSet.emit({
      lat: this.pickedLocation.lat,
      lng: this.pickedLocation.lng,
    });
  }

  private getMapImage(lat: number, lng: number, zoom: number) {
    // Your backend proxies Static Maps using a server IP-restricted key
    return `${environment.apiUrl}/api/maps/static?center=${lat},${lng}&zoom=${zoom}` +
      `&size=500x300&maptype=roadmap&markers=${lat},${lng}`;
  }
}
